module.exports = __webpack_public_path__ + "static/header-7afd31f6bbc044864e1ce2f5686a2c79.jpg";